import { TranslateService } from '@ngx-translate/core';
import { Utils } from 'app/infrastructure/utils';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Item } from 'app/models/item.inferface';
import { Observable } from 'rxjs';

import { ConfirmDialogComponent } from './dialogs-components/confirm-dialog/confirm-dialog.component';
import { DialogDescriptionComponent } from './dialogs-components/dialog-description/dialog-description.component';
import { AppFormDialogComponent } from './dialogs-components/app-form-dialog/app-form-dialog.component';
import { Form } from 'app/models/form';
import { FileListDialogComponent } from './dialogs-components/file-list-dialog/file-list-dialog.component';
import { FileDto } from 'app/models/file';
import { ConfirmDialogOptions } from 'app/models/confirm-dialog-options.models';
import { ConfirmMultiMessageDialogComponent } from './dialogs-components/confirm-multimessage-dialog/confirm-multimessage-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

export interface IConsultantForwardDialogParams {
    title: string,
    placeholder: string,
    consultants: Item[],
    consultationFormGroup: UntypedFormGroup,
    consultationFormGroupControlName: string
}

@Injectable()
export class DialogService {

    constructor(
        private dialog: MatDialog,
        private tr: TranslateService
    ) { }

    openConfirmDialog(title: string, message: string, options?: ConfirmDialogOptions): MatDialogRef<ConfirmDialogComponent> {
        if (Utils.isNullOrWhiteSpace(title)) {
            title = this.tr.instant('ALERT_DIALOG.TITLE');
        }
        return this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            height: 'auto',
            disableClose: true,
            data: { title, message, options }
        });
    }

    openConfirmMultiMessageDialog(title: string, messages: any[], options?: ConfirmDialogOptions): MatDialogRef<ConfirmMultiMessageDialogComponent> {
        if (Utils.isNullOrWhiteSpace(title)) {
            title = this.tr.instant('ALERT_DIALOG.TITLE');
        }
        return this.dialog.open(ConfirmMultiMessageDialogComponent, {
            width: '450px',
            height: 'auto',
            disableClose: true,
            data: { title, messages, options }
        });
    }

    openDialogDescription(title: string, placeholder: string, type: string, motivesData?: Item[]): MatDialogRef<DialogDescriptionComponent> {
        return this.dialog.open(DialogDescriptionComponent, {
            width: '350px',
            height: 'auto',
            disableClose: true,
            data: { title, placeholder, motivesData, type }
        });
    }

    openAppFormDialog(data: Form): MatDialogRef<AppFormDialogComponent> {
        return this.dialog.open(AppFormDialogComponent, {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            disableClose: true,
            data
        });
    }

    openFileListDialog(reportId: number, files: FileDto[], mimeType?: string): MatDialogRef<FileListDialogComponent> {
        return this.dialog.open(FileListDialogComponent, {
            width: '350px',
            height: 'auto',
            disableClose: false,
            data: {reportId, files, mimeType}
        });
    }

}
